
/* **********************
 * 緯度経度を取得する
 * **********************/ 
export const extractCoordinates = (text: string): number[] | null => {
    const regex = /(-?\d+\.\d+)\s*[,、]\s*(-?\d+\.\d+)/;
    const match = text.match(regex);
    if (match) {
        if(parseFloat(match[2]) > 90) {
            return [parseFloat(match[2]), parseFloat(match[1])];
        }
        return [parseFloat(match[1]), parseFloat(match[2])];
    }
    return null;
};
